module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[80]567.ea31ac8.woff2";